<template>
  <div class="spending-stats" v-loading="loading">
    <div class="group" v-for="g in groups" :key="g.type">
      <h3>{{ g.label }}</h3>
      <div class="cards">
        <div class="card" v-for="c in g.cards" :key="c.status" :class="c.cls">
          <div class="num">{{ c.count }}</div>
          <div class="label">{{ c.label }}</div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { getSpendingStatusCounts } from '@/request/api.js';

const STATUSES = [
  { key: 'DRAFT', label: '草稿', cls: 'gray' },
  { key: 'SUBMITTED', label: '已提交', cls: 'blue' },
  { key: 'AI_AUDITING', label: 'AI 审核中', cls: 'orange' },
  { key: 'MANUAL_AUDITING', label: '人工审核中', cls: 'orange' },
  { key: 'APPROVED', label: '已通过', cls: 'green' },
  { key: 'REJECTED', label: '已驳回', cls: 'red' },
  { key: 'SETTLED', label: '已结算', cls: 'green' }
];

export default {
  name: 'SpendingStatistics',
  data() {
    return {
      loading: false,
      groups: [
        { type: 'SUPPLIER', label: '供应商结算', cards: [] },
        { type: 'LABOR', label: '劳务结算', cards: [] }
      ]
    };
  },
  created() {
    this.load();
  },
  methods: {
    async load() {
      this.loading = true;
      try {
        for (const g of this.groups) {
          const resp = await getSpendingStatusCounts(g.type);
          const data = (resp.code === 200 && resp.data) || {};
          g.cards = STATUSES.map(s => ({
            status: s.key, label: s.label, cls: s.cls,
            count: data[s.key] || 0
          }));
        }
      } catch (e) {
        this.$message.error('统计加载失败');
      } finally {
        this.loading = false;
      }
    },
    refresh() { this.load(); }
  }
};
</script>

<style scoped>
.spending-stats { padding: 16px 0; }
.group { margin-bottom: 24px; }
.group h3 { margin: 0 0 12px; color: #303133; font-size: 16px; }
.cards { display: grid; grid-template-columns: repeat(auto-fill, minmax(160px, 1fr)); gap: 12px; }
.card {
  background: #fff; border: 1px solid #EBEEF5; border-radius: 6px;
  padding: 16px; text-align: center;
}
.card .num { font-size: 28px; font-weight: 600; color: #303133; }
.card .label { color: #909399; font-size: 13px; margin-top: 4px; }
.card.gray .num { color: #909399; }
.card.blue .num { color: #409EFF; }
.card.orange .num { color: #E6A23C; }
.card.green .num { color: #67C23A; }
.card.red .num { color: #F56C6C; }
</style>
